import { render, staticRenderFns } from "./AulasAguardandoProcessamento.vue?vue&type=template&id=4dd92488"
import script from "./AulasAguardandoProcessamento.vue?vue&type=script&lang=js"
export * from "./AulasAguardandoProcessamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports